import axios from "axios";

axios.defaults.baseURL = "./api";
axios.defaults.headers.common["If-Modified-Since"] =
  "Mon, 26 Jul 1997 05:00:00 GMT";
axios.defaults.headers.common["Cache-Control"] = "no-cache";
axios.defaults.headers.common["Pragma"] = "no-cache";
